import { render } from "./SystemProductList.vue?vue&type=template&id=9fb77158&scoped=true"
import script from "./SystemProductList.vue?vue&type=script&lang=js"
export * from "./SystemProductList.vue?vue&type=script&lang=js"

import "./SystemProductList.vue?vue&type=style&index=0&id=9fb77158&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb77158"]])

export default __exports__